import { render, nothing, html } from "lit-html";
import { classMap } from "lit-html/directives/class-map.js";
import { styleMap } from "lit-html/directives/style-map.js";
import { repeat } from "lit-html/directives/repeat.js";
import connect from "../../../shared/data-store/connect";
import {
	ACTION_SET_SCORE_FILTER,
	ACTION_RESET_SCORE_FILTER,
	store,
} from "./DataStore";
import { translate } from "../../../shared/l10n/translate";
import { track } from "../../tracker/EventTracker";
import { debounce } from "../../../shared/event/debounce";

const SCORES = [0, 85, 90, 95];

customElements.define(
	"esc-hotel-list-score-filter",
	class extends connect(HTMLElement, store) {
		constructor() {
			super();
			this.reviewScore = null;
			this.availableScores = null;
			this.hotelCountPerScore = null;
			this.debouncedDispatch = debounce(300, this.notifyStore.bind(this));
		}

		update(state, { counters }) {
			this.reviewScore = state.filters.reviewScore;
			this.hotelCountPerScore = counters.score;
			this.availableScores = SCORES.filter(
				score =>
					this.reviewScore >= score || this.hotelCountPerScore[score] > 0, // Chosen score filter will be always available.
			);

			this.render();
		}

		render() {
			const sliderWidthClasses = {
				"slider--1-of-4-ticks-active": this.availableScores.length <= 1,
				"slider--2-of-4-ticks-active": this.availableScores.length == 2,
				"slider--3-of-4-ticks-active": this.availableScores.length == 3,
			};
			const value = this.availableScores.indexOf(this.reviewScore);
			const sliderStyle = {
				"--esc-slider-progress": `${
					value > 0 ? (value * 100) / (this.availableScores.length - 1) : 0
				}%`,
			};

			const template = html`<label>
				<div class="slider-label filter-box__section-title">
					${translate("filter_score_label")}
					<span
						class="slider-label__value ${classMap({
							"slider-label__value--active": this.reviewScore,
						})}"
					>
						${
							this.reviewScore
								? html`${translate("filter_score_label_from", this.reviewScore)}%`
								: nothing
						}
					</span>
				</div>
				<div class="slider-container">
					<input
						class="slider slider--inverted-track ${classMap(
							sliderWidthClasses,
						)}"
						type="range"
						min="0"
						max=${this.availableScores.length - 1}
						step="1"
						style=${styleMap(sliderStyle)}
						.value=${value}
						@input=${this.onInput}
						@change=${this.onChange}
					/>
					<div class="slider__disabled-part"></div>
					<div class="slider__rule">
						${repeat(
							SCORES,
							(_, index) => index,
							score => html`
								<div class="slider__rule__label">
									<div>
										${score ? `${score}%` : translate("filter_score_label_all")}
										<span class="filter-hotel-count"
											>${this.hotelCountPerScore[score]}</span
										>
									</div>
								</div>
							`,
						)}
					</div>
				</div>
			</label>`;
			render(template, this, { host: this });
		}

		onInput({ target }) {
			this.reviewScore = SCORES[target.value];
			this.render();
			this.debouncedDispatch();
		}

		onChange() {
			track(
				"Filter",
				"Bewertungsfilter",
				`${this.reviewScore || "Alle"}${this.trackLabelSuffix}`,
			);
		}

		notifyStore() {
			if (this.reviewScore) {
				this.dispatchAction(ACTION_SET_SCORE_FILTER, this.reviewScore);
			} else {
				this.dispatchAction(ACTION_RESET_SCORE_FILTER);
			}
		}

		get trackLabelSuffix() {
			return this.getAttribute("track-label-suffix") || "";
		}
	},
);
